var scrollHash = {
  scrolling:false,
  load:function(){
    var scrollTimer = null;

    window.addEventListener("scroll",()=>{
      if(scrollTimer !== null){
        clearTimeout(scrollTimer);
      }
      scrollTimer = setTimeout(()=>{
        this.scrolling = false;
      },150);

    });

    var hash = window.location.hash;
    if(hash.indexOf("#st:") === 0){
      this.scrollTo(hash);

    }

  },
  scrollTo:function(hash){
    var elementDetails = hash.replace("#st:","");
    var [elementID,offset,mobileOnly] = elementDetails.split(":");

    if(mobileOnly == "1" && window.innerWidth > 700){
      return false;
    }
    this.scrollToElement(elementID,offset);

  },
  scrollToElement:function(elementID,offset){
    var element = document.getElementById(elementID);
    var elementBounds = element.getBoundingClientRect();
    var elementTop = elementBounds.top - window.scrollY;
    if(offset){
      elementTop = elementTop - offset;
    }

      if(!this.scrolling){
        console.log("NOT SCROLLING");
        window.scrollTo({top:elementTop,behavior:"smooth"});
      }
      else{
        console.log("TRY AGAIN");
        this.scrollToElement(elementID,offset);
      }

  }
}

window.addEventListener("DOMContentLoaded",function(){
//  scrollHash.load();
});
